import styled from 'styled-components';

export const Wrapper = styled('div')`
  margin: 0;
  z-index: 1;
  display: flex;
  justify-content: center;
`;
